import { observer } from 'mobx-react'
import React from 'react'

@observer
class ModalWrapper extends React.Component {

  handleModalClick(e){
    const { className } = e.target
    const { modalClass } = this.props
    const selection = document.getSelection()
    if(className && className === 'modal fade show' + ` ${modalClass ? modalClass : ''}`){
      this.props.close()
    }
  }

  render(){
    const { modalClass } = this.props
    const className = `modal fade show ${modalClass ? modalClass : ''}`
    return (
      <div
        className={className}
        onClick={e => this.handleModalClick(e)}
        role="dialog"
        style={{
          display: 'block'
        }}
      >
        <div className='modal-dialog'>
          <div className="modal-content">
            {this.props.children}
          </div>
        </div>
      </div>
    )
  }

}

export default ModalWrapper